<div class="crud-rows-panel" *ngIf="mode == 'LIST_DOCUMENTS'">
  <form [formGroup]="form">
    <div class="crud-rows-table-section">
      <div class="crud-rows-table-wrapper mat-table-wrapper">
        <mat-table formArrayName="formRows" #table [dataSource]="sortDataSource" matSort class="crud-rows-table"
          [matSortActive]="defaultSort" [matSortDirection]="defaultSortDirection" matSortDisableClear cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <ng-container matColumnDef="contentType">
            <mat-header-cell [crud-column-header]="columns.column('contentType')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.Document.contentType">
              Content Type
            </mat-header-cell>
            <mat-cell class="search-column-small" [ngClass]="{'row-selected': rowSelected(element)}"
              *matCellDef="let element; let index = index" [formGroupName]="index">{{element.contentType}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="contentTypeIcon">
            <mat-header-cell [crud-column-header]="columns.column('contentTypeIcon')" *matHeaderCellDef cdkDropList
              cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-tiny">
              <app-mime-type-icon [sizePx]="32"></app-mime-type-icon>
            </mat-header-cell>
            <mat-cell class="search-column-tiny" [ngClass]="{'row-selected': rowSelected(element)}"
              *matCellDef="let element; let index = index" [formGroupName]="index">
              <ng-container *ngIf="allowsOpen() && isOpenEnabled(element)">
                <a (click)="openDocument(element)" class="document-link" matTooltip="View"><app-mime-type-icon
                    [sizePx]="32" [mimeType]="element.contentType"></app-mime-type-icon></a>
              </ng-container>
              <ng-container *ngIf="!allowsOpen() || !isOpenEnabled(element)">
                <app-mime-type-icon [sizePx]="32" [mimeType]="element.contentType"></app-mime-type-icon>
              </ng-container>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="creationDate">
            <mat-header-cell [crud-column-header]="columns.column('creationDate')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.Document.creationDate">
              Created
            </mat-header-cell>
            <mat-cell class="search-column-small" [ngClass]="{'row-selected': rowSelected(element)}"
              *matCellDef="let element; let index = index" [formGroupName]="index">
              {{element.creationDate | uimDateFormat:'dateTime'}}
            </mat-cell>
          </ng-container>


          <ng-container matColumnDef="filename">
            <mat-header-cell [crud-column-header]="columns.column('filename')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-medium"
              i18n="@@type.Document.filename">
              File Name
            </mat-header-cell>
            <mat-cell class="search-column-medium" [ngClass]="{'row-selected': rowSelected(element)}"
              *matCellDef="let element; let index = index" [formGroupName]="index">
              <span *ngIf="!showInlineFileLinks">{{element.filename}}</span>
              <span *ngIf="showInlineFileLinks">
                <button type="button" *ngIf="allowsDownload()" [disabled]="!isDownloadEnabled(element)"
                  mat-raised-button color="accent" (click)="downloadDocument(element)" class="action-button-tiny"
                  color="false" matTooltip="Download">
                  <mat-icon>file_download</mat-icon>
                </button>
                &nbsp;
                <button type="button" *ngIf="allowsOpen()" [disabled]="!isOpenEnabled(element)" mat-raised-button
                  color="accent" (click)="openDocument(element)" class="action-button-tiny" color="false"
                  matTooltip="View">
                  <mat-icon>file_open</mat-icon>
                </button>
                &nbsp;
                <a *ngIf="allowsOpen() && isOpenEnabled(element)" (click)="openDocument(element)"
                  class="document-link">{{element.filename}}</a>
                <span *ngIf="!allowsOpen() || !isOpenEnabled(element)">{{element.filename}}</span>
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="filePath">
            <mat-header-cell [crud-column-header]="columns.column('filePath')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-large"
              i18n="@@type.Document.filePath">
              Full Path
            </mat-header-cell>
            <mat-cell class="search-column-large" [ngClass]="{'row-selected': rowSelected(element)}"
              *matCellDef="let element; let index = index" [formGroupName]="index">
              {{element.filePath}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="lastModifiedDate">
            <mat-header-cell [crud-column-header]="columns.column('lastModifiedDate')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.Document.lastModifiedDate">
              Last Modified
            </mat-header-cell>
            <mat-cell class="search-column-small" [ngClass]="{'row-selected': rowSelected(element)}"
              *matCellDef="let element; let index = index" [formGroupName]="index">
              {{element.lastModifiedDate | uimDateFormat:'dateTime'}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="size">
            <mat-header-cell [crud-column-header]="columns.column('size')" *matHeaderCellDef mat-sort-header cdkDropList
              cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.Document.size">
              Size
            </mat-header-cell>
            <mat-cell class="search-column-small" [ngClass]="{'row-selected': rowSelected(element)}"
              *matCellDef="let element; let index = index" [formGroupName]="index">
              {{element.size|fileSize}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="noData">
            <mat-footer-cell *matFooterCellDef class="search-column-large result-summary">
              <span *ngIf="!retrieving">No Documents Found</span>
              <div *ngIf="retrieving">
                <mat-spinner></mat-spinner>
              </div>
            </mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions search-column-verysmall mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="search-column-actions search-column-verysmall mat-elevation-z9">
              <button type="button" *ngIf="isShowAction('download') && allowsDownload()"
                [disabled]="!isDownloadEnabled(element)" mat-raised-button color="accent"
                (click)="downloadDocument(element)" class="action-button-small">Download</button>
              <button type="button" *ngIf="isShowAction('open') && allowsOpen()" [disabled]="!isOpenEnabled(element)"
                mat-raised-button color="primary" (click)="openDocument(element)"
                class="action-button-small">Open</button>
              <button type="button" *ngIf="isShowAction('delete') && allowsDelete()"
                [disabled]="!isDeleteEnabled(element)" mat-raised-button color="accent" (click)="deleteRow(element)"
                class="action-button-small">Delete</button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; let i = index; columns: columns.displayedColumns;" class="search-table"
            (click)="rowClicked(row)" [ngClass]="rowClass(row)"></mat-row>
          <mat-footer-row *matFooterRowDef="rows && rows.length ? [] : ['noData']" class="search-table"
            [ngClass]="{'hidden' : rows && rows.length}">
          </mat-footer-row>

        </mat-table>
      </div>
      <!--
      <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
      </mat-paginator>
      -->
    </div>
  </form>
</div>

<div class="upload-files-container" *ngIf="mode == 'UPLOAD_DOCUMENTS'">
  <app-file-upload-selector (files)="uploadFilesChanged($event)" [fileValidator]="fileValidator"></app-file-upload-selector>
</div>
